
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * NewsServiceId enum
 */
class NewsServiceId {
  /**
   * Initialize enum with a given value
   * @param {NewsServiceId|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof NewsServiceId) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!NewsServiceId}
   * @param {!NewsServiceId} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof NewsServiceId)) {
      throw new TypeError('Instance of NewsServiceId is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!NewsServiceId}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!NewsServiceId}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === NewsServiceId.UNDEFINED.value) {
      return 'UNDEFINED'
    }
    if (this.value === NewsServiceId.TRADING_CENTRAL.value) {
      return 'TRADING_CENTRAL'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!NewsServiceId}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!NewsServiceId}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!NewsServiceId} Created enum
   */
  static fromObject (other) {
    return new NewsServiceId(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
NewsServiceId.UNDEFINED = new NewsServiceId(0 + 0)
// noinspection PointlessArithmeticExpressionJS
NewsServiceId.TRADING_CENTRAL = new NewsServiceId(0 + 1)

export { NewsServiceId };

/**
 * Fast Binary Encoding NewsServiceId field model
 */
class FieldModelNewsServiceId extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelNewsServiceId}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelNewsServiceId}
   * @param {NewsServiceId=} defaults Default value, defaults is new NewsServiceId()
   * @returns {!NewsServiceId} Result value
   */
  get (defaults = new NewsServiceId()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new NewsServiceId(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelNewsServiceId}
   * @param {!NewsServiceId} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelNewsServiceId };
